import Image from "next/legacy/image";
import PropTypes from "prop-types";
import { useState } from "react";
import { getStrapiMedia } from "utils/media";
import { mediaPropTypes } from "utils/types";

import placeholder from "../../public/images/placeholder.png";

const NextImage = ({ media, ...props }) => {
  const fallback = {
    data: {
      id: "1",
      attributes: {
        local: true,
        alternativeText: "placholder.png",
        width: placeholder.width,
        height: placeholder.height,
        mime: "image/svg+xml",
        url: placeholder.src,
        formats: null,
      },
    },
  };
  const { url, alternativeText, width, height, local } =
    media === null ? fallback.data.attributes : media.attributes;
  const heightCheck = height === null ? "100%" : height;
  const widthCheck = width === null ? "100%" : width;
  const [error, setError] = useState(false);
  const fallbackUrl = placeholder.src;

  const loader = ({ src, width }) => {
    return getStrapiMedia(src, width, local);
  };

  // The image has a fixed width and height
  if (props.width && props.height) {
    return (
      <Image loader={loader} src={url} alt={alternativeText || ""} {...props} />
    );
  }

  if (props.full) {
    return (
      <Image
        priority={props.priority}
        loader={loader}
        layout="fill"
        objectFit="cover"
        src={error ? fallbackUrl : url}
        alt={alternativeText || ""}
        onError={() => setError(true)}
      />
    );
  }

  if (props.fixed) {
    <Image
      priority={props.priority}
      loader={loader}
      layout="fixed"
      width={widthCheck}
      height={heightCheck}
      // objectFit="contain"
      src={error ? fallbackUrl : url}
      alt={alternativeText || ""}
      onError={() => setError(true)}
    />;
  }

  // The image is responsive
  return (
    <Image
      priority={props.priority}
      loader={loader}
      layout="responsive"
      width={widthCheck}
      height={heightCheck}
      objectFit="contain"
      src={error ? fallbackUrl : url}
      alt={alternativeText || ""}
      onError={() => setError(true)}
    />
  );
};

Image.propTypes = {
  media: mediaPropTypes,
  className: PropTypes.string,
};

export default NextImage;
